/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'

// Components
import {Box, Container, Text} from '@chakra-ui/react'
import Seo from '../../components/seo'
import StoreLocatorContent from '../../components/store-locator-modal/store-locator-content'

// Others
import {StoreLocatorContext, useStoreLocator} from '../../components/store-locator-modal/index'
import {useIntl} from 'react-intl'

const StoreLocator = () => {
    const storeLocator = useStoreLocator()
    const intl = useIntl()

    return (
        <StoreLocatorContext.Provider value={storeLocator}>
            <Box data-testid="store-locator-page" bg="gray.50" py={[8, 16]}>
                <Seo
                    title={intl.formatMessage({
                        id: 'store_locator.page.title',
                        defaultMessage: 'Store Locator'
                    })}
                    description={intl.formatMessage({
                        id: 'store_locator.page.description',
                        defaultMessage: 'Store Locator Page'
                    })}
                />
                <Text
                    as="h1"
                    textStyle="Regular 45XLarge"
                    marginBottom="25px"
                    paddingY={2}
                    textAlign="center"
                >
                    {intl.formatMessage({
                        id: 'store_locator.title',
                        defaultMessage: 'Find a Store'
                    })}
                </Text>
                <Container
                    overflowY="scroll"
                    paddingTop={8}
                    width={['90%']}
                    bg="white"
                    paddingBottom={14}
                    marginTop={8}
                    marginBottom={8}
                    borderRadius="base"
                >
                    <StoreLocatorContent />
                </Container>
            </Box>
        </StoreLocatorContext.Provider>
    )
}

StoreLocator.getTemplateName = () => 'store-locator'

StoreLocator.propTypes = {}

export default StoreLocator
